import http from '../http'
import * as types from '../mutation-types';

export const state = {
    status: '',
    departments: null,
    list: null,
    roles: null,
    pagination: {}
};

export const getters = {
    loadStatus: state => state.status,
    departments: state => state.departments,
    list: state => state.list,
    roles: state => state.roles,
    pagination: state => state.pagination,
};

export const mutations = {
    /** LOAD */
    [types.LOAD_DEPARTMENTS_LOADING](state) {
        state.status = 'loading'
    },
    [types.LOAD_DEPARTMENTS_SUCCESS](state, {data, meta}) {
        state.status = 'success'
        state.departments = data
        state.pagination = meta.pagination || {}
    },
    [types.LOAD_DEPARTMENTS_ERROR](state) {
        state.status = 'error'
    },
    /** LIST */
    [types.LIST_DEPARTMENTS_LOADING](state) {
        state.status = 'loading'
    },
    [types.LIST_DEPARTMENTS_SUCCESS](state, {data}) {
        state.status = 'success'
        state.list = data
    },
    [types.LIST_DEPARTMENTS_ERROR](state) {
        state.status = 'error'
    },
    /** ROLES */
    [types.LIST_ROLES_LOADING](state) {
        state.status = 'loading'
    },
    [types.LIST_ROLES_SUCCESS](state, {data}) {
        state.status = 'success'
        state.roles = data
    },
    [types.LIST_ROLES_ERROR](state) {
        state.status = 'error'
    },
};

export const actions = {
    load({commit}, params = {}) {
        return new Promise((resolve, reject) => {
            commit(types.LOAD_DEPARTMENTS_LOADING);
            params = Object.fromEntries(Object.entries(params).filter(([key, value]) => ['page'].includes(key)))
            const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
            http.get('departments?' + queryString).then(({data}) => {
                commit(types.LOAD_DEPARTMENTS_SUCCESS, data)
                resolve(data)
            }).catch(({response}) => {
                commit(types.LOAD_DEPARTMENTS_ERROR)
                reject(response.data)
            })
        })
    },
    list({commit}) {
        return new Promise((resolve, reject) => {
            commit(types.LIST_DEPARTMENTS_LOADING);
            http.get('departments/list').then(({data}) => {
                commit(types.LIST_DEPARTMENTS_SUCCESS, data)
                resolve(data)
            }).catch(({response}) => {
                commit(types.LIST_DEPARTMENTS_ERROR)
                reject(response.data)
            })
        })
    },
    roles({commit}) {
        return new Promise((resolve, reject) => {
            commit(types.LIST_ROLES_LOADING);
            http.get('departments/roles').then(({data}) => {
                commit(types.LIST_ROLES_SUCCESS, data)
                resolve(data)
            }).catch(({response}) => {
                commit(types.LIST_ROLES_ERROR)
                reject(response.data)
            })
        })
    },
};
